<template>
  <div>Some documents</div>
</template>

<script>
export default {}
</script>